module.exports = __webpack_public_path__ + "img/effects-13.9311c02f.png";